/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aspect_RatioInputs */

const en_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect Ratio`)
};

const fr_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format d’image`)
};

const de_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenverhältnis`)
};

const it_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporzioni`)
};

const ru_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соотношение сторон`)
};

const es_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relación de aspecto`)
};

const zh_cn2_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长宽比`)
};

const ja_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アスペクト比`)
};

const hi_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आस्पेक्ट अनुपात`)
};

const pt_pt2_aspect_ratio = /** @type {(inputs: Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporção da tela`)
};

/**
* | output |
* | --- |
* | "Aspect Ratio" |
*
* @param {Aspect_RatioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const aspect_ratio = /** @type {((inputs?: Aspect_RatioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aspect_RatioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_aspect_ratio(inputs)
	if (locale === "de") return de_aspect_ratio(inputs)
	if (locale === "it") return it_aspect_ratio(inputs)
	if (locale === "ru") return ru_aspect_ratio(inputs)
	if (locale === "es") return es_aspect_ratio(inputs)
	if (locale === "zh-CN") return zh_cn2_aspect_ratio(inputs)
	if (locale === "ja") return ja_aspect_ratio(inputs)
	if (locale === "hi") return hi_aspect_ratio(inputs)
	if (locale === "pt-PT") return pt_pt2_aspect_ratio(inputs)
	return en_aspect_ratio(inputs)
});